export default __webpack_public_path__ + "static/media/object--traffic-light.6dd482e0.png";